import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { TriangleWarning } from "components/icons/TriangleWarning";
import React from "react";

type ConfirmNoShareholderModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmNoShareholderModal: React.FC<
  ConfirmNoShareholderModalProps
> = ({ open, onClose, onConfirm }) => {
  return (
    <Modal.Root open={open} onOpenChange={onClose} modal={false}>
      <Modal.Content size="small" useCustomOverlay>
        <Modal.Body>
          <div>
            <span className="t-text-orange t-flex t-items-center t-justify-center t-w-10 t-h-10 t-rounded-full t-shadow-[0px_0px_0px_4px_rgba(255,220,78,0.15)] t-border t-border-orange-20 t-border-solid t-bg-yellow-20">
              <TriangleWarning />
            </span>
            <p className="t-mb-2 t-text-subtext t-text-text-100 t-mt-5">
              Confirm no shares have been issued?
            </p>
            <div className="t-text-body-sm t-text-text-30">
              Marking this confirms that the entity has not issued any shares.{" "}
              <span className="t-font-bold">
                This may affect your federal filings.
              </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button type="button">Go back</Button>
          </Modal.RawClose>
          <Button customType="primary" onClick={onConfirm}>
            Confirm
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
